import api from './api';
import { ExpoChannel, ExpoRelease, ExpoDevice } from '../models/expo';

const EXPO_API_URL = '/expo';

// Channel endpoints
export const getExpoChannels = async (): Promise<ExpoChannel[]> => {
  const response = await api.get(`${EXPO_API_URL}/channels/`);
  return response.data;
};

export const getExpoChannel = async (id: number): Promise<ExpoChannel> => {
  const response = await api.get(`${EXPO_API_URL}/channels/${id}/`);
  return response.data;
};

export const createExpoChannel = async (channel: Partial<ExpoChannel>): Promise<ExpoChannel> => {
  const response = await api.post(`${EXPO_API_URL}/channels/`, channel);
  return response.data;
};

export const updateExpoChannel = async (id: number, channel: Partial<ExpoChannel>): Promise<ExpoChannel> => {
  const response = await api.put(`${EXPO_API_URL}/channels/${id}/`, channel);
  return response.data;
};

export const deleteExpoChannel = async (id: number): Promise<void> => {
  await api.delete(`${EXPO_API_URL}/channels/${id}/`);
};

// Release endpoints
export const getExpoReleases = async (channelId?: number): Promise<ExpoRelease[]> => {
  let url = `${EXPO_API_URL}/releases/`;
  if (channelId) {
    url = `${EXPO_API_URL}/channels/${channelId}/releases/`;
  }
  const response = await api.get(url);
  return response.data;
};

export const getExpoRelease = async (id: number): Promise<ExpoRelease> => {
  const response = await api.get(`${EXPO_API_URL}/releases/${id}/`);
  return response.data;
};

export const createExpoRelease = async (release: Partial<ExpoRelease>): Promise<ExpoRelease> => {
  const response = await api.post(`${EXPO_API_URL}/releases/`, release);
  return response.data;
};

export const updateExpoRelease = async (
  id: number, 
  release: Partial<ExpoRelease>
): Promise<ExpoRelease> => {
  const response = await api.put(`${EXPO_API_URL}/releases/${id}/`, release);
  return response.data;
};

export const deleteExpoRelease = async (id: number): Promise<void> => {
  await api.delete(`${EXPO_API_URL}/releases/${id}/`);
};

export const publishExpoRelease = async (id: number): Promise<ExpoRelease> => {
  const response = await api.post(`${EXPO_API_URL}/releases/${id}/publish/`);
  return response.data;
};

export const rollbackExpoRelease = async (id: number): Promise<ExpoRelease> => {
  const response = await api.post(`${EXPO_API_URL}/releases/${id}/rollback/`);
  return response.data;
};

// Device endpoints
export const getExpoDevices = async (): Promise<ExpoDevice[]> => {
  const response = await api.get(`${EXPO_API_URL}/devices/`);
  return response.data;
};

export const getExpoDevice = async (id: number): Promise<ExpoDevice> => {
  const response = await api.get(`${EXPO_API_URL}/devices/${id}/`);
  return response.data;
};
